import React, { useContext, useEffect } from 'react';
import type { NextPage } from 'next';

import { useRouter } from 'next/router';

interface IProps {

}

const Default: NextPage<IProps> = ({ }) => {
  const router = useRouter()

  useEffect(() => {
    router.push('/', '/', {
      shallow: true
    })
  }, [])

  return (
    <div>
    </div>
  )
};

export default Default;
